import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.01 11.9a.95.95 0 0 1-.554-.182 1.07 1.07 0 0 1-.368-.484 1.16 1.16 0 0 1-.056-.623c.038-.21.133-.401.273-.552L6.59 6.507 3.305 2.955a1.1 1.1 0 0 1-.224-.35 1.15 1.15 0 0 1 .211-1.189 1 1 0 0 1 .328-.236.93.93 0 0 1 .772.008 1 1 0 0 1 .324.241l3.992 4.315c.187.202.292.477.292.763s-.105.56-.292.762l-3.992 4.315a.96.96 0 0 1-.706.316"
    }, null, -1)
  ]))]))
}
export default { render: render }